import React from 'react';
import { Link } from 'react-router-dom';
import { RETURNS_LABEL, subst } from '../../helpers/routes';

const getButtonSuffix = (index, total) => {
  if (total === 1) {
    return '';
  }

  return ` ${index + 1}`;
};

const ShippingLabel = (props) => {
  const { label, index, total } = props;

  const buttonSuffix = getButtonSuffix(index, total);

  return (
    <div className="card-group__item">
      <div className="card card--secondary card--action-right-at-768">
        <div className="card__content">
          {!label.hasShipped && (
            <p className="body2">
              {`Print and attach this label to the top of the ${index > 0 ? 'additional ' : ''} package.`}
            </p>
          )}

          {label.hasShipped && (
            <p className="body2">
              {`Your package ${label.packageStatusText}. The UPS tracking number is: ${label.trackingID}`}
            </p>
          )}
        </div>
        <div className="card__action">
          {!label.hasShipped && (
            <Link className="button button--primary" to={subst(RETURNS_LABEL, { id: label.trackingID })} target="_blank">
              {`Print Shipping Label ${buttonSuffix}`}
            </Link>
          )}
          {label.hasShipped && (
            <a
              className="button button--primary"
              href={`http://wwwapps.ups.com/WebTracking/track?loc=en_US&track.x=Track&trackNums=${label.trackingID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Track via UPS
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShippingLabel;
